module.exports = __webpack_public_path__ + "static/empty.3518fe72.png";